import React, { useState } from "react";
import SearchBar from "../SearchBar";
import { Grid, styled, Box, useTheme } from "@mui/material";
import BasicDatePicker from "../DatePicker";
import Dropdown from "../FilterDropdown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";


const StyledBox = styled(Box)(({ theme }) => ({
  padding: "10px",
  borderRadius: "15px",
  backgroundColor: "rgba(0, 176, 80, 0.05)",
  "& .displayEnd": {
    display: "flex",
    justifyContent: "flex-end",
    background: "grey",
    paddingTop: "10px",
    columnGap: "8px",
    [theme.breakpoints.down("md")]: {
      columnGap: "0px",
    },
  },
  "& .MuiInputBase-root": {
    color: "#0B1426 !important",
    height: "44px",
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-input": {
    color: "#0B1426",
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(1),
  },
  "& > *": {
    width: "100%",
  },
}));

const Filter = ({
  searchPlaceholder,
  onSearch,
  onFromDateChange,
  onToDateChange,
  onCategoryChange,
  onConstructionStatusChange,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [category, setCategory] = useState("");
  const [constructionStatus, setConstructionStatus] = useState("");
  const handleSearch = (event, value) => {
    setSearchQuery(value);
    onSearch(value);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    onFromDateChange(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    onToDateChange(date);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
    onCategoryChange(value);
  };

  const handleConstructionStatusChange = (value) => {
    setConstructionStatus(value);
    onConstructionStatusChange(value);
  };

  const handleClear = () => {
    setSearchQuery("");
    setFromDate(null);
    setToDate(null);
    setCategory("");
    setConstructionStatus("");

    onSearch("");
    onFromDateChange(null);
    onToDateChange(null);
    onCategoryChange("");
    onConstructionStatusChange("");
  };

  return (
    <StyledBox>
      <Grid container spacing={2} alignItems="center">
        <StyledGrid item xs={12} sm={6} md={3}>
          <SearchBar
            placeholder={searchPlaceholder}
            onSearch={handleSearch}
            value={searchQuery}
            options={[]}
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={2}>
          <BasicDatePicker
            label="From Date"
            onDateChange={handleFromDateChange}
            value={fromDate}
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={2}>
          <BasicDatePicker
            label="To Date"
            onDateChange={handleToDateChange}
            value={toDate}
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={2}>
          <Dropdown
            options={["Residential", "Villa", "Commercial"]}
            onChange={handleCategoryChange}
            value={category}
            placeholder="Property Type"
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={2}>
          <Dropdown
            options={["Ready to Move", "Under Construction"]}
            onChange={handleConstructionStatusChange}
            value={constructionStatus}
            placeholder="Construction Status"
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={1}>
          <Tooltip title="Reset Filters">
            <IconButton onClick={handleClear} size="large">
              <RestartAltIcon />
            </IconButton>
          </Tooltip>
        </StyledGrid>

      </Grid>
    </StyledBox>
  );
};

export default Filter;
